import { render, staticRenderFns } from "./MeetingAgendaCard.vue?vue&type=template&id=689fa93e&"
import script from "./MeetingAgendaCard.vue?vue&type=script&lang=js&"
export * from "./MeetingAgendaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('689fa93e')) {
      api.createRecord('689fa93e', component.options)
    } else {
      api.reload('689fa93e', component.options)
    }
    module.hot.accept("./MeetingAgendaCard.vue?vue&type=template&id=689fa93e&", function () {
      api.rerender('689fa93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/MeetingAgendaCard.vue"
export default component.exports